/* eslint-disable prefer-template */
import React from 'react';

export const renderLabel = (status) => {
  switch (status) {
    case 'HandoverPending':
      return 'Inactivation Pending';

    case 'InActive':
      return 'Inactive';

    case 'ActivationPending':
      return 'Take Over Pending';

    case 'TakeoverPending':
      return 'Transfer Pending';

    case 'Active':
      return 'Active';

    default:
      return status;
  }
};

export const buildCompanySearchLabel = (companyName, sapCompanyCode) => (
  [companyName, sapCompanyCode]
    .filter((v) => v != null && String(v).trim() !== '')
    .map((v) => String(v).trim())
    .join(' ')
);

export const buildVesselSearchLabel = (vesselName, vesselCode, sapVesselCompanyCode, status) => (
  [vesselName, vesselCode, sapVesselCompanyCode, status]
    .filter((v) => v != null && String(v).trim() !== '')
    .map((v) => String(v).trim())
    .join(' ')
);

export const buildVesselDropdownLabel = (vesselName, vesselCode, sapVesselCompanyCode, status) => (
  <div className="flex flex-col">
    <span className="font-sm text-gray-100">
      {vesselName}
      {vesselCode && (
        <span className="text-gray-100 text-sm">
          (
          {vesselCode}
          )
        </span>
      )}
      {sapVesselCompanyCode && (
        <span className="text-gray-100 text-sm">
          (
          {sapVesselCompanyCode}
          )
        </span>
      )}
    </span>
    <span className="text-gray-200 text-xs italic font-normal">{renderLabel(status)}</span>
  </div>
);

const formatDropdownOptions = (
  array,
  labelField,
  valueField,
  extraLabel,
  forVessel = false
) => {
  if (array?.length > 0) {
    return array
      .filter(Boolean)
      .map((item) => {
        let label;
        let value;
        let searchLabel = '';

        if (forVessel && item?.[labelField]) {
          label = buildVesselDropdownLabel(
            item?.[labelField],
            item?.[extraLabel],
            item?.sapVesselCompanyCode,
            item?.status
          );
          searchLabel = buildVesselSearchLabel(
            item?.[labelField],
            item?.[extraLabel],
            item?.sapVesselCompanyCode,
            item?.status
          );

          value = item?.vesselRevisionId ?? item?.[valueField];
        } else if (item?.[labelField] && item?.[extraLabel]) {
          label = `${item?.[labelField]} ${item?.[extraLabel]}`;
          searchLabel = label;
          value = item?.[valueField];
        } else {
          label = item?.[labelField];
          searchLabel = item?.[labelField];
          value = item?.[valueField];
        }

        return {
          ...item,
          label,
          value,
          searchLabel
        };
      });
  }
  return [];
};

export default formatDropdownOptions;
